import {useListView} from '../../core/ListViewProvider'
import {BundlesListToolbar} from './BundleListToolbar'
import {BundlesListGrouping} from './BundlesListGrouping'
import {BundlesListSearchComponent} from './BundlesListSearchComponent'

const BundlesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <BundlesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <BundlesListGrouping /> : <BundlesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {BundlesListHeader}
